import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

declare var $: any;

@Component({
  selector: 'app-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss']
})
export class RichTextComponent extends ComponentBase implements OnInit {

  constructor() {
    super()
  }

  ngOnInit() {
  }

  public options: Object = {
    language: 'pt_br',
    theme: 'dark',
    linkAlwaysBlank: true,
    placeholderText: '',
    charCounterCount: true,
    charCounterMax: 5000,
    height: 300,
    autofocus: false,
    //fullPage: true,
    //aviaryKey: ADOBE_CREATIVE_CLOUD_KEY,
    aviaryOptions: {
      displayImageSize: true,
      theme: 'dark'
    },
    events : {
      'froalaEditor.blur' : function(e, editor) {
        console.log(editor.selection.get().focusNode.data);
      }
    }
  };

  ngBlurTextArea(attribute: any){
    console.log(attribute.key+ " - " +attribute.value);
  }
}
